import { Tone } from "tone";
import { Sampler } from "tone";
import { Loop } from "tone";
import { Transport } from "tone";
import { getDefaultsFromInstance } from "tone/build/esm/core/util/Defaults";

var sampler = null;
var isSetup = false;
var dataset = []; //array of {x, y} points

//range of pitch in MIDI numbers
var lowPitch = 20;
var highPitch = 200;

//note values
var noteLength = 10; //length of note (unit?)
var secondPerUnit = .4  ; //for calculating pauses
var xGroupDelay = .03    //for spacedOut points with same x value


//range of dataset y values
var minValue = 0;
var maxValue = 50;

var spacedOut = false;
var playing = false;

var muted = true; //will only be unmuted when keyboard accessibility controls are used

/**
 * Sonification: Provide global functions to setup, play, and stop data sonification
 */

export default {
    install (Vue, options) {
        Vue.prototype.$setupSonification = function(min, max) {
            return setup(min, max);
        },
        Vue.prototype.$updateSonificationData = function(data, spaceOut) {
            return updateSonificationData(data, spaceOut);
        },
        Vue.prototype.$playSonification = function(delay) {
            return play(delay);
        },
        Vue.prototype.$interruptSonification = function() {
            return interrupt();
        },
        Vue.prototype.$stopSonification = function() {
            return stop();
        }
        Vue.prototype.$isReady = function() {
            return isReady();
        },
        Vue.prototype.$unmuteSonification = function() {
            return unmute();
        },
        Vue.prototype.$muteSonification = function() {
            return mute();
        }
    }
}

function unmute(){
    muted = false;
}

function mute(){
    muted = true;
}

/**
 * @description returns ready status sonification, requires sampler is ready and data is set
 * @returns boolean value
 */
function isReady(){
    return isSetup && dataset !== [] && !muted;
}

/**
 * @description sets up sampler object using sample tones. will change "isSetup" value to true when complete
 */
async function setup(min, max){
    minValue = min;
    maxValue = max;

    sampler = new Sampler({ 
        urls: { 
            "21": require("@/assets/common/sonification-note-01.wav"), //can't use URL in deployment, it gives a CORS error
        },
        release: 1,
        onload: () => {
            isSetup = true;
        }
    }).toDestination();
}

/**
 * @description updates data to be sonified
 * @param nextDataset array of {x, y} values
 * @param spaceOut boolean - if true, values with same x value will spaced out slightly for clarity
 */
function updateSonificationData(nextDataset, spaceOut){
    if (!spaceOut){
        dataset = nextDataset;
    }
    else{
        spacedOut = true;
        var spacedDataset = [];
    
        for (var i = 0; i < nextDataset.length; i++){
            var point = nextDataset[i];
            var pointSorted = false;
            
            for (var j = 0; j < spacedDataset.length; j++){
                xGroup = spacedDataset[j];
    
                if (point.x === xGroup.x){
                    xGroup.y.push(point.y);
                    pointSorted = true;
                }
            }
    
            if (!pointSorted){
                var xGroup = {};
                xGroup.x = point.x;
                xGroup.y = [point.y]
                spacedDataset.push(xGroup);
            }
        }
    
        //console.log(spacedDataset);
        dataset = spacedDataset;
    }
}

async function interrupt(){
    if (playing){
        sampler.dispose();
        playing = false;
        await setup(minValue, maxValue);
        play(0);
    }
    else{
        play(0);
    }
}


/**
 * @description plays sonification if sampler is ready and dataset exists. play logic works slightly differently if dataset is spacedOut
 * @param delay number in seconds
 */
function play(delay){
    var baseDelay = 0;

    if (delay){
        baseDelay = delay;
    }

    // console.log("isSetup: " + isSetup);
    // console.log("hasData: " + dataset !== []);
    // console.log("playing: " + playing)

    if (isReady() && !playing){
        // console.log("starting sonification...");
        playing = true;
        const now = sampler.context.now()

        if (!spacedOut){
            for (var i = 0; i < dataset.length; i++){
                var point = dataset[i];
                var note = sonifyValue(point.y);
                sampler.triggerAttackRelease(note.toString(), noteLength, now + secondPerUnit * point.x);

                if (i === dataset.length - 1){
                var seconds = noteLength + (secondPerUnit * point.x) * 1000;
                    setTimeout(() => {
                        playing = false;
                    }, seconds);
                }
                
            }


        }
        else{
            for (var i = 0; i < dataset.length; i++){
                var xGroup = dataset[i];
                var x = xGroup.x;
                var yValues = xGroup.y;
                var baseTime = secondPerUnit * x;
                //console.log("playing notes at x value: " + x);

                for (var j = 0; j < yValues.length; j++){
                    var y = yValues[j];
                    var note = sonifyValue(y);
                    sampler.triggerAttackRelease(note.toString(), noteLength, now + baseTime + j * xGroupDelay + baseDelay);
                }
            }
        }
    }
}


function stop(){
    console.log("stopping");
    if (playing){
        isSetup = false;
        sampler.dispose();
        playing = false;
        setup(minValue, maxValue)
    }
}

/**
 * @description converts y value to tone value
 * @param value -- should be between minValue and maxValue
 * @returns integer value with value mapped between lowTone and highTone (MIDI number)
 */
function sonifyValue(value){
    //console.log("sonfiying: " + value);
    var percent = (value - minValue) / (maxValue - minValue);
    //console.log("percent: " + percent);
    
    var note = lowPitch + Math.round(percent * (highPitch - lowPitch) / 3) * 3;
    //console.log("note: " + note)
    
    return note;
}


